import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { AppConfig } from '../../../utils/app-config.service';
import { AutoNumericDirective } from '../../../directives/auto-numeric.directive';
import { BaseUI } from '../../base.ui';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { FundTransfer, Trader } from '../../../domain/data';
import { FundTransferInterface, GetExternalTradersUseCase, GetTradersUseCase } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-transfer-form-fund',
    templateUrl: './transfer-form-fund.component.html',
    styleUrls: ['./transfer-form-fund.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TransferFormFundComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy, OnInit {
    public initialAmount = 0;
    public amountTouched = false;
    public traders: Trader[] = [];
    public externalTraders: Trader[] = [];

    @Input()
    public fundTransfer: FundTransferInterface = new FundTransfer();

    @Input()
    public showCancel = true;

    @Output()
    public cancel: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public submit: EventEmitter<FundTransferInterface> = new EventEmitter<FundTransferInterface>();

    @ViewChild('fundAmountDirective')
    fundAmountDirective: AutoNumericDirective;

    constructor(
        parentEvents: ParentEvents,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        private getExternalTradersUseCase: GetExternalTradersUseCase,
        private getTradersUseCase: GetTradersUseCase
    ) {
        super(parentEvents);
    }

    get minimumInvestment(): number {
        return AppConfig.settings.contribution?.min || 0;
    }

    ngOnInit() {
        this.getExternalTraders();
        this.getTraders();
    }

    private getExternalTraders() {
        this.getExternalTradersUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.externalTraders = transaction.data as Trader[];
                    this.cdr.detectChanges();
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    private getTraders() {
        this.getTradersUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.traders = transaction.data as Trader[];
                    this.cdr.detectChanges();
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('fundTransfer' in changes && changes.fundTransfer.currentValue) {
            this.initialAmount = this.fundTransfer.amount;
            this.cdr.detectChanges();
        }
    }

    onManagerChange() {
        const trader = this.traders.find((it) => String(it.id) === this.fundTransfer.externalTransferManager);
        if (trader) {
            this.fundTransfer.externalTransferManagerName = trader.name;
        }
    }

    onAmountChange() {
        if (this.fundAmountDirective) {
            this.fundTransfer.amount = this.fundAmountDirective.value;
            this.cdr.detectChanges();
        }
    }

    public onCancel() {
        this.cancel.emit();
    }

    public onSubmit() {
        this.submit.emit(this.fundTransfer);
    }
}
